import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { Grid, Paper } from "@mui/material";
import { useState } from "react";
import { useDelayCategoriesQuery } from "../hooks/queries/useDelayCategoriesQuery";
import { useRealtimeInvalidation } from "../hooks/queries/useRealtimeInvalidation";
import { TableCategories } from "./components/TableCategories";

export const CatalogCategoriesPage = () => {
  // Filters
  const [assetId, setAssetId] = useState(0);
  const [includeInactives, setIncludeInactives] = useState(false);
  const [error, setError] = useState("");

  useRealtimeInvalidation();

  const { data: categories = [], isLoading } = useDelayCategoriesQuery(
    assetId,
    includeInactives,
    (err) => setError(err.message),
  );

  return (
    <>
      <HelmetDexteel title={"Delay Categories"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
            }}
          >
            <TableCategories
              categories={categories}
              isLoading={isLoading}
              assetId={assetId}
              setAssetId={setAssetId}
              includeInactives={includeInactives}
              setIncludeInactives={setIncludeInactives}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
